const PROGRAM_KEY_SEPARATOR = '::';
const PROGRAM_KEY_OCCURRENCE_SEPARATOR = '#';

export const getProgramLenderName = program => program?.lenderName?.trim() || null;

const getBaseProgramKey = program => {
  const id =
    program?.program?.programId ?? program?.program?.internalName ?? program?.productName ?? '';
  const lenderName = getProgramLenderName(program);

  return lenderName ? `${id}${PROGRAM_KEY_SEPARATOR}${lenderName}` : String(id);
};

export const getProgramKey = program => program?.programKey ?? getBaseProgramKey(program);

export const withUniqueProgramKeys = programs => {
  if (!Array.isArray(programs)) {
    return programs;
  }

  const occurrences = new Map();

  return programs.map(program => {
    const baseKey = getBaseProgramKey(program);
    const occurrence = (occurrences.get(baseKey) ?? 0) + 1;

    occurrences.set(baseKey, occurrence);

    return {
      ...program,
      programKey:
        occurrence === 1 ? baseKey : `${baseKey}${PROGRAM_KEY_OCCURRENCE_SEPARATOR}${occurrence}`,
    };
  });
};

export const hasProgramLenderNames = (programs = []) =>
  (programs || []).some(program => !!getProgramLenderName(program));
